/**
 * Функция вызова протокола с оверлеем
 */
$.fn.protocolControls = function() {
    const $self = $(this);
    const $protocolLayout = $self.find('.js-protocols-layout');
    const $hideProtocolBtn = $protocolLayout.find('.js-close-btn');
    const $protocolsWrapper = $self.find('.js-protocols-wrapper');

    let protocolsIsOpened = false;

    /**
     * Показать протокол
     */
    const showProtocol = () => {
        SVK.makeFixedHtml();
        $protocolLayout.addClass('opened');
        $protocolLayout.on('transitionend', function() {
            protocolsIsOpened = true;
        });
    };

    /**
     * Скрыть протокол
     */
    const hideProtocol = () => {
        SVK.makeUnfixedHtml();
        $protocolLayout.removeClass('opened');
        $protocolLayout.on('transitionend', function() {
            protocolsIsOpened = false;
        });
    };

    /**
     * Инициализация ивентов
     */
    const initEvents = () => {

        $(document).on('click', '.js-show-protocol', function () {
            showProtocol();
        });

        $hideProtocolBtn.on('click', function () {
            hideProtocol();
        });

        $(document).on('click', function(e) {
            if ($protocolsWrapper.has(e.target).length === 0 && protocolsIsOpened){
                hideProtocol();
            }
        });
    };

    /**
     * Инициализация плагина
     */
    const init = () => {
        initEvents();
    };

    init();
};
